export enum NotificationType {
	Critical = 'Critical',
	Error = 'Error',
	Information = 'Information',
	Success = 'Success',
	Warning = 'Warning',
}

export const nonCriticalNotificationTypes = [
	NotificationType.Error,
	NotificationType.Information,
	NotificationType.Success,
	NotificationType.Warning,
];
